import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useSSRGeneratorNew(generatorId: string, options?: { enabled?: boolean }) {
  const { data: elasticData, isError: elasticIsError } = useQuery({
    queryKey: ['generator-retrieve', generatorId],
    queryFn: () => BackendService.instance.generators.retrieve(generatorId),
    staleTime: 1000 * 60 * 5,
    // Defaults to fetching, as it always has. Callers that hold a second
    // generator id behind a flag pass `false` so the request only happens for
    // the teachers who can actually reach it.
    enabled: options?.enabled ?? true,
  });
  return {
    generator: elasticData,
    isError: elasticIsError,
  };
}

export default useSSRGeneratorNew;
